import { useState } from 'react';

type CallbackFunction<T extends any[]> = (...args: T) => Promise<void>;

export const useButtonLock = () => {
  const [isLocked, setIsLocked] = useState<boolean>(false);

  const lock = () => setIsLocked(true);
  const unlock = () => setIsLocked(false);

  return {
    isLocked,
    lock,
    unlock,
    handleClick:
      <T extends any[]>(callback: CallbackFunction<T>) =>
      async (...args: T) => {
        if (isLocked) return;
        lock();
        try {
          await callback(...args);
        } catch (error) {
          unlock();
          throw error;
        }
      },
  };
};
